module.exports = __webpack_public_path__ + "img/success3.8ae7be8a.png";